window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotSuggester ??= {};
window.AppointmentBooking.SlotSuggester.Models ??= {};

AppointmentBooking.SlotSuggester.Models.Base = class Base extends Backbone.RelationalModel {
  // Syntactic sugar for defining properties
  static prop(...args) {
    return Object.defineProperty(this.prototype, ...Array.from(args));
  }

  static get(propName, getter) {
    return Object.defineProperty(this.prototype, propName, { get: getter });
  }
};
